export default __webpack_public_path__ + "static/media/bowery.4a44355b.png";